/**
 * Enum of calendar views.
 */
export enum CalendarView {
  Agenda = 'month-agenda',
  Day = 'day',
  Month = 'month-grid',
  Week = 'week'
}
